import React from "react";
import { Steps } from "antd";

const STEP_ITEMS = [
  {
    title: "Step 1",
    description: "Challenge content",
  },
  {
    title: "Step 2",
    description: "Challenge profile",
  },
  {
    title: "Step 3",
    description: "Done",
  },
];

export default function PublishChallengeSteps({ current = 0 }) {
  return (
    <div className="publish-steps-wrap">
      <Steps current={current} items={STEP_ITEMS} size="small" />
    </div>
  );
}
